export const STATUS_CODES = {
  UNAUTHORIZED: 401,

  INTERNAL_SERVER_ERROR: 500,
};
